import Button from "atoms/buttons/button";
import PublishStatus from "models/enumerations/publish-status";
import React, { forwardRef } from "react";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { EnhancedContentPanelFooterProps } from "../enhanced-content-panel-footer";

// -----------------------------------------------------------------------------------------
// #region Interfaces
// -----------------------------------------------------------------------------------------

interface EnhancedContentUnpublishActionProps
    extends Pick<EnhancedContentPanelFooterProps, "enhancedContent"> {
    onClick: () => void;
    ref?: React.RefObject<HTMLButtonElement>;
}

// #endregion Interfaces

// -----------------------------------------------------------------------------------------
// #region Components
// -----------------------------------------------------------------------------------------

const EnhancedContentUnpublishAction = forwardRef(
    (
        props: EnhancedContentUnpublishActionProps,
        ref: React.Ref<HTMLButtonElement>
    ) => {
        const { enhancedContent, onClick, ref: buttonRef } = props;

        const { globalState } = useGlobalState();

        const canUnpublish =
            ((globalState.currentIdentity?.isPublisher() ||
                globalState.currentIdentity?.isAdmin()) &&
                enhancedContent.getPublishStatus() ===
                    PublishStatus.Published &&
                !enhancedContent.hasUnpublishedChanges()) ??
            false;

        if (!canUnpublish) {
            return null;
        }

        return (
            <Button
                accessibleText={`Unpublish NFPA Insights`}
                onClick={onClick}
                ref={buttonRef}>
                Unpublish
            </Button>
        );
    }
);

// #endregion Components

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default EnhancedContentUnpublishAction;

// #endregion Exports
